import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class ReportGeneralSalesService {
    async getGeneralReport(params: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.GENERAL_SALES}`, params);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const reportGeneralSalesService = new ReportGeneralSalesService();
export default reportGeneralSalesService;